import { compileTheme } from './compile.js';
import { tokens } from './tokens.js';
export { compileTheme } from './compile.js';
const base = {
    accentText: '#ffffff',
    card: tokens.color.card,
    border: tokens.color.border,
    text: tokens.color.text,
    textMuted: tokens.color.textMuted,
    success: tokens.color.success,
    successBg: tokens.color.successBg,
    warning: tokens.color.warning,
    warningBg: tokens.color.warningBg,
    danger: tokens.color.danger,
    dangerBg: tokens.color.dangerBg,
};
/**
 * Tmave neutraly sdilene napric tematy (P5) - jen akcent/accentSoft se lisi
 * per produkt (viz `themes` nize). Hodnoty zmereny pres `contrastRatio`
 * (viz REPORT-portal-P5ab.md) PRED zapisem, ne odhadem:
 * text/card 14.45:1, text/canvas 15.85:1, textMuted/card 6.99:1,
 * textMuted/canvas 7.67:1 (min AA 4.5:1).
 * `success/warning/danger` popredi jsou SVETLEJSI nez svetly rezim (puvodni
 * tmave tona #116149 na tmavem pozadi vychazi ~1.8:1, hluboko pod AA) -
 * zmereno: success 7.69:1, warning 8.87:1, danger 5.82:1 proti svym `*Bg`.
 */
const darkBase = {
    canvas: '#14161b',
    card: '#1c1f26',
    border: '#2a2e37',
    text: '#eef0f3',
    textMuted: '#a3a9b5',
    success: '#4ade80',
    successBg: '#123529',
    warning: '#facc15',
    warningBg: '#3a2c0d',
    danger: '#f87171',
    dangerBg: '#3a1613',
    shadowMenu: 'rgb(0 0 0 / 0.4)',
};
/**
 * Produktova temata. Fakturace ma dva kandidaty akcentu (A emerald, B teal) —
 * oba v galerii, vybere R.B.; default je A.
 */
export const themes = [
    {
        ...base,
        name: 'reos',
        accent: tokens.color.accent.reos,
        accentSoft: '#e7eefb',
        canvas: tokens.color.canvas.reos,
        chart: [tokens.color.accent.reos, '#f0c24b', '#e8632e', '#9db9e8', '#c3cbd6'],
        // Vychozi akcent (#2963cb) neprojde "accent/card (odkazy)" 4.5:1 min
        // (jen 2.94:1) - zesvetlena varianta 6.76:1/7.42:1 proti card/canvas
        // (WYSIWYG-PLAN §1.1). Svetly akcent potrebuje TMAVY text na tlacitkach
        // (bily by mel jen 2.44:1 - selhalo by accentText/accent).
        dark: { ...darkBase, accent: '#6ea8f7', accentText: '#16181d', accentSoft: '#22344c' },
    },
    {
        ...base,
        name: 'kokpit',
        accent: tokens.color.accent.kokpit,
        accentSoft: '#eceafd',
        canvas: tokens.color.canvas.kokpit,
        chart: [tokens.color.accent.kokpit, '#f0c24b', '#e8632e', '#b3b4f5', '#c6c8d2'],
        // Vychozi akcent (#4041e8) neprojde ani 3:1 UI par proti darkBase.card/canvas
        // (2.47:1 / 2.71:1), natoz 4.5:1 pro "accent/card (odkazy)" -
        // zesvetlena varianta 5.82:1/6.39:1.
        dark: { ...darkBase, accent: '#8f8ff5', accentText: '#16181d', accentSoft: '#2b2b57' },
    },
    {
        ...base,
        name: 'fakturace-a',
        accent: tokens.color.accent.fakturaceA,
        accentSoft: '#def0e9',
        canvas: tokens.color.canvas.fakturace,
        chart: [tokens.color.accent.fakturaceA, '#f0c24b', '#e8632e', '#93cdb8', '#c5cbc9'],
        // Vychozi akcent projde jen 3:1 UI par (accent/canvas), ale "accent/card
        // (odkazy)" vyzaduje 4.5:1 (jen 3.01:1) - zesvetlena varianta 8.58:1/9.41:1.
        dark: { ...darkBase, accent: '#34d399', accentText: '#16181d', accentSoft: '#123a2e' },
    },
    {
        ...base,
        name: 'fakturace-b',
        accent: tokens.color.accent.fakturaceB,
        accentSoft: '#dcefed',
        canvas: tokens.color.canvas.fakturace,
        chart: [tokens.color.accent.fakturaceB, '#f0c24b', '#e8632e', '#8fccc7', '#c5cbc9'],
        // Stejny duvod jako fakturace-a: "accent/card (odkazy)" 4.5:1 min, vychozi
        // jen 3.01:1 - zesvetlena varianta 8.86:1/9.72:1.
        dark: { ...darkBase, accent: '#2dd4bf', accentText: '#16181d', accentSoft: '#0f2e2b' },
    },
];
/** Kompilace vsech temat do jednoho CSS bloku (galerie / produkty si vyberou). */
export function compileAllThemes() {
    return themes.map(compileTheme).join('\n\n');
}
//# sourceMappingURL=themes.js.map